import { FC } from 'react';
import {
  LinearProgress,
  LinearProgressProps,
  Theme,
  Typography,
  useTheme,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const ProgressWithInfo: FC<
  React.PropsWithChildren<ProgressWithInfoProps>
> = props => {
  const { info, value, total, formatTotal, onCancel, ...linearProgressProps } =
    props;
  const { classes } = useStyles();
  const theme = useTheme();

  return (
    <div className={classes.progressInner}>
      <LinearProgress
        value={value}
        classes={{
          bar: classes.bar,
          colorPrimary: classes.colorPrimary,
        }}
        sx={{ width: '100%' }}
        variant={!value || value === 100 ? 'indeterminate' : 'determinate'}
        {...linearProgressProps}
      />
      <div className={classes.summary} data-testid='gradual-updates'>
        {info && (
          <Typography
            lineHeight={1.5}
            variant='caption'
            color={theme.palette.progress.textColor}>
            {info}
          </Typography>
        )}
        {formatTotal && (
          <Typography
            lineHeight={1.5}
            variant='caption'
            color={theme.palette.progress.textColor}>
            {formatTotal}
          </Typography>
        )}
      </div>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  progressInner: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'start',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(1.5),
  },
  bar: {
    backgroundColor: `${theme.palette.progress.barColor} !important`,
  },
  colorPrimary: {
    backgroundColor: `${theme.palette.progress.trackColor} !important`,
  },
  summary: {
    display: 'inline-flex',
    flexDirection: 'column',
    marginBlockEnd: theme.spacing(0.5),
  },
}));

export interface ProgressWithInfoProps extends LinearProgressProps {
  info?: string;
  value: number;
  total?: number;
  formatTotal?: string;
  onCancel?: () => void;
}

export default ProgressWithInfo;
